<template>
    <section class="pf-table">
        <section class="table-list">
            <el-table  :data='data' :size='size'
                       :border  ='isBorder'
                       :max-height="height"
                       @select='select'
                       @select-all='selectAll'
                       @row-click="clickRow"
                       @current-change="handleCurrentChange"
                       v-loading='loading'
                       :show-header='showHeader'
                       :highlight-current-row='!multiple'
                       :defaultSelections='defaultSelections'
                       style="width: 100%"
                       :show-summary="showSummary"
                       :summary-method="sumaryMethod"
                       :row-class-name="rowClassName"
                       :rowKey="getRowKey"
                       :expand-row-keys="expandKeys"
                       ref="pfTable">
                <el-table-column v-if="isExtend" type="expand">
                    <template slot-scope="props">
                        <component :is="expandComponent.name" :rowData="props.row" v-on:refresh="refresh"></component>
                    </template>
                </el-table-column>
                <el-table-column v-if="isSelection" type="selection" align="center" :reserve-selection="reserveSelection" :selectable="selectable"></el-table-column>
                <el-table-column v-if="isIndex" type="index" :label="indexLabel" align="center" width="50"></el-table-column>
                <!-- 数据栏 -->
                <el-table-column v-for="(column, index) in columns" :sortable="column.sortable"
                                 :key="'columns'+index" :prop="column.prop" :label="column.label" :width="column.width" :min-width="column.minWidth" :align="column.align" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <template v-if="!column.render">
                            <template v-if="column.formatter">
                                <span v-html="column.formatter(scope.row, column)"></span>
                            </template>
                            <template v-else>
                                <el-input type="text" size="mini" v-model="scope.row[column.prop]" v-if="scope.row.edit && (!column.type || column.type == 'input')"></el-input>
                                <el-input type="number" size="mini" v-model="scope.row[column.prop]" v-if="scope.row.edit && column.type == 'number'"></el-input>
                                <el-input-number size="mini" v-model="scope.row[column.prop]"  :min="0" :max="100" controls-position="right" v-if="scope.row.edit && column.type == 'stepNumber'"></el-input-number>
                                <el-input type="textarea" size="mini" v-model="scope.row[column.prop]" v-if="scope.row.edit && column.type == 'textarea'"></el-input>
                                <pf-dic v-model="scope.row[column.prop]" v-if="scope.row.edit && column.type == 'dic'" :needAll="column.needAll" :type="column.typeName"></pf-dic>
                                <pf-select v-model="scope.row[column.prop]" :options="column.options" v-if="scope.row.edit && column.type == 'select'"></pf-select>
                                <el-date-picker size="mini" v-model="scope.row[column.prop]" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-if="scope.row.edit && column.type == 'date'"></el-date-picker>
                                <span v-if="!scope.row.edit">{{scope.row[column.prop]}}</span>
                            </template>
                        </template>
                        <template v-else>
                            <expand-dom :column="column" :row="scope.row" :render="column.render" :index="index" :rowIndex="scope.$index"></expand-dom>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column ref="fixedColumn" label="操作" align="center" :width="operates.width" :fixed="operates.fixed"
                                 v-if="operates && (!operates.type || operates.type == 'button') && operates.list.filter(_x=>_x.show === true).length > 0">
                    <template slot-scope="scope">
                        <span v-for="(btn, key) in operates.list" :key="key">
                            <el-button class="operation" :type="btn.type" :size="size" :icon="btn.icon"
                                      :disabled="(btn.label=='全景'&&!scope.row.qjt||btn.disabled)||(btn.label=='定位'&&!scope.row.dkzb||btn.disabled)"
                                      v-if="btn.show && (!scope.row.hiddeMenus || scope.row.hiddeMenus && scope.row.hiddeMenus.filter(item=>item.id == btn.id).length == 0)" :key='btn.id'
                                       :plain="btn.plain" @click.native.stop.prevent="btn.method(key,scope.row, scope.$index)">
                                       {{(btn.label==='修改'&&scope.row.status===1)?'审核':btn.label }}
                            </el-button>
                            <el-divider direction="vertical" v-if="key < operates.list.length - 1 && (!scope.row.hiddeMenus || scope.row.hiddeMenus && scope.row.hiddeMenus.filter(item=>item.id == btn.id).length == 0)" :key="key"></el-divider>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column ref="fixedColumn" label="操作" align="center" :width="operates.width" :fixed="operates.fixed"
                                 v-if="operates && operates.type == 'dropdown' && operates.list.filter(_x=>_x.show === true).length > 0">
                    <template slot-scope="scope">
                        <el-dropdown v-if="!scope.row.hiddeMenus || (!!scope.row.hiddeMenus && scope.row.hiddeMenus.length < operates.list.length)">
                            <span class="el-dropdown-link">
                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <span v-for="(btn, key) in operates.list" :key="key">
                                    <el-dropdown-item class="mini-dropdown-item" @click.native.stop.prevent="btn.method(key,scope.row)" v-if="btn.show && (!scope.row.hiddeMenus || scope.row.hiddeMenus && scope.row.hiddeMenus.filter(item=>item.id == btn.id).length == 0)" :key="key">{{ btn.label }}</el-dropdown-item>
                                </span>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
        </section>
    </section>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'list',
  props: {
    url: String,
    // 表格型号：mini,medium,small
    size: {type: String, default: 'mini'},
    isBorder: {type: Boolean, default: false},
    loading: {type: Boolean, default: false},
    showHeader: {type: Boolean, default: true},
    tableHandles: {type: Array, default: () => []},
    // 表格列配置
    columns: { type: Array, default: () => []},
    // 表格数据
    data: { type: Array, default: () => []},
    // 操作按钮组 label: 文本，type :类型（primary / success / warning / danger / info)
    operates: {},
    // 是否显示表格复选框
    isSelection: {type: Boolean, default: false},
    reserveSelection: {type: Boolean, default: false}, // 是否记录分页选中
    // 是否展开行
    isExtend: {type: Boolean, default: false},
    // 展开行内容
    expandColumn: {type: Object, default: () => {}},
    defaultSelections: { type: [Array, Object], default: () => null},
    // 是否显示表格索引
    isIndex: {type: Boolean, default: false},
    indexLabel: {type: String, default: '序号'},
    expandComponent: {type: Object, default: () => {}},
    rowClassName: {type: String | Function, default: ''}, //
    rowKey: {type: String | Array, default: 'id'},
    enableEdit: {type: Boolean, default: false}, // 是否可编辑
    multiple: {type: Boolean, default: true}, // 是否可多选
    expandKeys: {type: Array, default: () => []}, // 默认展开行rowKey
    showSummary: {type: Boolean, default: false}, // 是否显示合计
    sumText: {type: String, default: '合计'}, // 合计字段名称
    sumaryMethod: {type: Function, default: null}, // 合计方法
    isCheck: {type: Boolean, default: true}, // 是否可以选中
    height: {type: String | Number, default: 400 } // 高度
    // tableRowClassName: {type:Function, default:null}, // 给Table 中的某一行添加 class
  },
  components: {
    expandDom: {
      functional: true,
      props: {
        row: Object,
        render: Function,
        rowIndex: Number,
        index: Number,
        column: {
          type: Object,
          default: null
        }
      },
      render: (h, ctx) => {
        const params = {
          row: ctx.props.row,
          index: ctx.props.index,
          rowIndex: ctx.props.rowIndex
        }
        if (ctx.props.column) {
          params.column = ctx.props.column
        }
        return ctx.props.render(h, params)
      }
    }
  },
  data() {
    return {
    }
  },
  created () {
    this.$on('update', function () {
      this.$refs.pfTable.bodyWrapper.scrollTop = 0
    })
    if (this.expandComponent) {
      this.registerComponent(this.expandComponent)
    }
  },
  mounted() {
    // TODO 计算高度
  },
  methods: {
    // 默认进来选中
    toggleRowSelection (row, index) {
      this.$refs.pfTable.toggleRowSelection(row, true)
    },
    // checkbox是否可以选中
    selectable (row, index) {
      return this.isCheck
    },
    // 单选
    handleCurrentChange(row) {
      if (!this.isSelection) {
        this.$emit('handleSelect', row)
      }
    },
    // 表格勾选
    select(rows, row) {
      this.$emit('handleSelect', rows)
    },
    // 全选
    selectAll(rows) {
      this.$emit('handleSelect', rows)
    },
    // 单击行
    clickRow(row, column, event) {
      this.$emit('rowClick', row)
      if (this.enableEdit) {
        this.data.forEach(element => {
          element.edit = false
        })
        row.edit = true
        this.$set(this.data, event.currentTarget.rowIndex, row)
      }
    },
    // 保存行
    getEditData() {
      return this.data
    },
    // 刷新
    refresh() {
      // this.$emit('refresh')
    },
    getRowKey(row) {
      if (Array.isArray(this.rowKey)) {
        const keys = []
        this.rowKey.forEach(element => {
          keys.push(row[element])
        })
        return keys.join('_')
      } else {
        return row[this.rowKey]
      }
    },
    registerComponent(expand) {
      const url = expand.moduleType + '/' + expand.name
      return import('@/views/' + url + '.vue').then(component => Vue.component(expand.name, component.default))
    }
  },
  watch: {
    'data'(value) {
      value.forEach(element => {
        if (typeof element.edit == 'undefined') {
          element.edit = false
        }
      })
    },
    'defaultSelections'(val) {
      this.$nextTick(function () {
        if (Array.isArray(val)) {
          val.forEach(row => {
            this.$refs.pfTable.toggleRowSelection(row)
          })
        } else {
          this.$refs.pfTable.toggleRowSelection(val)
        }
      })
    }
  }
}
</script>
<style scoped>
    .table-list .cell /deep/ .el-dropdown{
        font-size: 14px;
        color: #068bff;
        cursor: pointer;
    }
    .table-list .el-table /deep/ th {
        color: #515A6E;
        font-size: 14px;
        font-weight: 600;
        background: #F8F8F9;
    }
    .table-list .el-table /deep/ td  {
        color: #333;
        font-size: 14px;
    }
    .mini-dropdown-item.el-dropdown-menu__item{
        font-size: 14px;
    }
    .gray-bg /deep/ td.el-table__expanded-cell {
        background: #f8f8f8;
    }
    .gray-bg /deep/ .el-table__expanded-cell:hover {
        background-color: #f8f8f8 !important;
    }
    .el-table--enable-row-transition /deep/ .el-table__body td.el-table__expanded-cell {
        -webkit-transition: none;
        transition: none;
    }
    .el-table /deep/ td div.el-tabs {
        background: #fff;
        padding: 15px;
        border: 1px solid rgb(244, 244, 244);
    }
    .pf-table > .table-list > /deep/ .el-table > div > table > tbody > tr > td.el-table__expanded-cell,
    .pf-table > .table-list > /deep/ .el-table > div > table > tbody > tr > td.el-table__expanded-cell:hover {
        background: #fbfbfb !important;
        padding: 20px 30px;
    }
    .operation /deep/ > span{
        font-weight: normal;
    }
    .operation-link{
        white-space: normal;
        font-weight: normal;
        font-size: 14px;
    }
    .el-table /deep/ .el-link, .el-table .el-button {
        font-size: 14px;
        font-weight: 400;
    }
    .el-table /deep/ .el-card__header span {
        font-size: 14px;
        font-weight: bold;
    }
    .el-table /deep/ .warning-row {
        background: oldlace;
    }
    .el-table /deep/ .primary-row {
        background: #ecf5ff;
    }
</style>
